import { saleCloseoutApi } from '../api';

export const saleCloseoutRepo = {
    getAll: (params) =>
        saleCloseoutApi.getAll(params),

    getById: (closeoutId) =>
        saleCloseoutApi.getById(closeoutId),

    getByShop: (shopId, params) =>
        saleCloseoutApi.getByShop(shopId, params),

    getTotalByShop: (shopId, params) =>
        saleCloseoutApi.getTotalByShop(shopId, params),

    getBySeller: (shopSellerId, params) =>
        saleCloseoutApi.getBySeller(shopSellerId, params),

    getTotalBySeller: (shopSellerId, params) =>
        saleCloseoutApi.getTotalBySeller(shopSellerId, params),

    create: (data) =>
        saleCloseoutApi.create(data),

    update: (closeoutId, data) =>
        saleCloseoutApi.update(closeoutId, data),
};